import { render, staticRenderFns } from "./LocalisedFieldIndicator.vue?vue&type=template&id=8601eb3a&scoped=true"
import script from "./LocalisedFieldIndicator.vue?vue&type=script&lang=js"
export * from "./LocalisedFieldIndicator.vue?vue&type=script&lang=js"
import style0 from "./LocalisedFieldIndicator.vue?vue&type=style&index=0&id=8601eb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8601eb3a",
  null
  
)

export default component.exports